import type { EditorView } from '@milkdown/kit/prose/view';
import type { Node as ProseMirrorNode } from '@milkdown/kit/prose/model';

export interface NodeAtCursor {
  pos: number;
  node: ProseMirrorNode;
  depth: number;
}

/**
 * Find an ancestor node of a specific type at the current cursor position.
 * Walks up the document tree from cursor depth to find the first matching node.
 */
export function getNodeAtCursor(view: EditorView, nodeName: string): NodeAtCursor | null {
  const { $from } = view.state.selection;
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    if (node.type.name === nodeName) {
      return { pos: $from.before(depth), node, depth };
    }
  }

  return null;
}
